module.exports = __webpack_public_path__ + "mobile/img/busagent-img1.5fc8047a.png";